module.exports = __webpack_public_path__ + "img/kr-product-final-card1-bg.7fe400f.png";